<template>
  <div class="openbox-wai index">
    <div class="slide">
      <mySlide />
    </div>
    <div class="openbox">
      <div class="w1500">
        <div class="back-box-w  flex flex-ac flex-jsb">
          <div class="back-box flex flex-ac" @click="goIndex">
            <i class="iconfont icon-back" />
            <span>返回</span>
          </div>
          <div class="voice-cart-box flex-0 flex flex-ac">
            <div class="voice-item flex flex-ac" :class="{'voice-item-active':cartState}">
              <el-switch v-model="cartState" active-color="#FFC400" inactive-color="#BBB9B9" @change="cartStateChange">
              </el-switch>
              <div class="t">动画</div>
            </div>
            <div class="voice-item flex flex-ac" :class="{'voice-item-active':voiceState}">
              <el-switch v-model="voiceState" active-color="#FFC400" inactive-color="#BBB9B9" @change="voiceStateChange">
              </el-switch>
              <div class="t">音效</div>
            </div>
            <div class="voice-item flex flex-ac" @click="$refs['RulePopup'].toggle('OpenBox')">
              <div class="gui-bo flex flex-ac flex-jc">
                <i class="el-icon-s-order"></i>
              </div>
              <div class="t">规则</div>
            </div>
          </div>
        </div>
        <div class="kai-conm">
          <div class="conlist-warp" :class="'conlist-warp'+kaiBox">
            <div v-for="i in kaiBox" :key="i" class="li-div">
              <div class="bei1">
                <img :src="box_obj.img_main" class="img_main" />
                <img :src="box_obj.img_active" class="img_active" />
              </div>
              <div class="name p-1" style="font-size:14px;padding:0 10px;">{{ box_obj.name }}</div>
              <div class="money-warp flex flex-jc flex-ac">
                <img src="@/assets/images/money.png" class="money-img" />
                <span>{{ box_obj.price }}</span>
              </div>
            </div>
          </div>
          <div v-if="chaMoney!=0" class="error flex flex-ac">
            <i class="el-icon-warning-outline"></i>
            <span>余额不足，无法开启{{ kaiBox }}个箱子</span>
          </div>
          <div v-if="type!='active'" class="openbox-bottom flex flex-ac flex-jc">
            <div class="con-num flex flex-ac">
              <div v-for="i in 5" :key="i" class="mun-li" :class="i==kaiBox ? 'con-num-check' : ''" @click="chooseNum(i)">
                <span>x{{ i }}</span>
              </div>
            </div>
            <div class="con-btn-box flex flex-ac">
              <div class="con-btn-w" :class="{'con-btn-w-d':chaMoney!=0}" @click="buyBox">
                <div class="con-btn flex flex-jc flex-ac">
                  <span>支付</span>
                  <img src="@/assets/images/money.png" class="money-img" />
                  <span>{{ (price * kaiBox).toFixed(2)}}</span>
                </div>
              </div>
              <template v-if="chaMoney!=0">
                <span class="split-huo">或</span>
                <div class="con-btn-w con-btn-w-c" @click="buyPrice">
                  <div class="con-btn flex flex-jc flex-ac">
                    <span>充值</span>
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span>{{ chaMoney }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 动画弹窗 -->
    <div class="kai-box-open csgo-mask flex flex-ac flex-jc" v-if="openBoxState">
      <div class="kai-warp-box">
        <div class="open-line" ref="openLine"></div>
        <div class="kaibox-warp">
          <div class="kaibox-item" v-for="(item, index) in imgList" :key="index">
            <ul :class="['kaibox-ul'+index,openBoxState&&isThree ? 'ul-animation-three'+item.zhongIndex :'',openBoxState&&!isThree ? 'ul-animation-five'+item.zhongIndex :'']">
              <li v-for="(item1, index1) in item.imgs" :key="index1" :data="item1.name" :class="`flex-0 flex flex-ac flex-jc ` + parseColor(item1,'color','key')">
                <img :src="item1.img" class="kaibox-img" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--中奖完成后盒子-->
    <div v-if="winState">
      <mywin :winList="winList" :winState="winState" winStatus="1" @winexchange="winexchange($event)" @winget="winget($event)" @winX="winX($event)"></mywin>
    </div>
    <div class="skin-list-box w1500P75">
      <div v-if="latelynewList.length" class="skin-list-item">
        <div class="csgo-title">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t">最近掉落</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="revisionSkin">
          <ul>
            <swiper class="openbox-swiper" :options="swiperOptions" style="width: 100%;">
              <swiper-slide v-for="item in latelynewList" :key="item.id" class="swiper-slide">
                <li class="skin-li" :class="parseColor(item,'color')" style="width: 100% !important;">
                  <div class="li-div li-div-center">
                    <span v-if="item.box_name" class="ico">{{ item.box_name }}</span>
                    <div class="rate">{{ item.probability }}%</div>
                    <div class="bei">
                      <img :src="item.imageUrl" class="img_active" />
                    </div>
                    <div class="name p-1">{{ item.skin_name }}</div>
                    <div class="money-warp">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <span>{{ item.price }}</span>
                    </div>
                    <div class="color-line" :style="'background-color:'+parseColor(item,'color','color')"></div>
                  </div>
                </li>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </ul>
        </div>
      </div>
      <div class="skin-list-item">
        <div class="csgo-title">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t">此箱子中的饰品</div>
            <img src="@/assets/images/title-label.png" />
          </div>
          <!-- <div class="des">便宜出好货，体验一次开多个箱子的爽感</div> -->
        </div>
        <div class="revisionSkin">
          <ul>
            <li v-for="item in skin_list" :key="item.id" class="skin-li" :class="parseColor(item,'color')">
              <div class="li-div li-div-center">
                <span v-if="item.exteriorName" class="ico">{{ item.exteriorName }}</span>
                <div class="rate">{{ item.probability }}%</div>
                <div class="bei">
                  <img :src="item.img" class="img_active" />
                </div>
                <div class="name p-1">{{ item.name }}</div>
                <div class="money-warp">
                  <img src="@/assets/images/money.png" class="money-img" />
                  <span>{{ item.price }}</span>
                </div>
                <div class="color-line" :style="'background-color:'+parseColor(item,'color','color')"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 分享-->
    <div v-show="dialogFormVisible" id="mask" @click="dialogFormVisible=false">
      <div class="">
        <div class="share-btn">
          <el-input v-model="url" autocomplete="off" style="width: 50vw"></el-input>
          <el-button class="btn" type="warning" @click.stop="copyUrl()">复制</el-button>
        </div>
      </div>
    </div>
    <audio controls ref="notify4" class="audio" @play="onPlay" @error="handleAudioError">
      <source src="@/assets/audio/open_box6s.mp3" />
    </audio>
    <audio controls ref="notify" class="audio">
      <source src="@/assets/audio/open_box2.mp3" />
    </audio>
    <myhomebot></myhomebot>
    <div class="commonBg"></div>
    <RulePopup ref="RulePopup" />

  </div>
</template>

<script>
import mywin from "@/components/my_win.vue";
import RulePopup from "@/components/rule-popup.vue"
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
import { parseColor } from "@/assets/js/util.js";

export default {
  components: { mywin, myhomebot, mySlide, RulePopup },
  data() {
    return {
      img: "",
      voiceState: true,
      // 是否开启动画
      cartState: true,
      latelynewList: [],
      loading: false,
      url: window.location.href,
      dialogFormVisible: false,
      winState: false,
      openBoxState: false,
      box_id: this.$route.query.box_id,
      box_name: "",
      box_obj: {},
      price: 0,
      totalPrice: 0,
      skin_list: [],
      skins_types: [],
      kaiBox: 1,
      winList: [],
      imgList: [],
      isThree: false,
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto'
      },
      chaMoney: 0,
      parseColor,
      type: ''
    };
  },
  watch: {
    // 监听路由变化
    '$route': {
      handler(to, from) {
        if (to.query.box_id !== from.query.box_id) {
          if (this.$route.query.type) {
            this.type = this.$route.query.type
          }
          this.box_id = this.$route.query.box_id
          this.voiceState = this.$store.state.voiceState
          this.cartState = this.$store.state.cartState
          // this.buyBox()
          this.getBoxInfo()
          this.getWinPeo()
        }
      },
      immediate: false  // 首次挂载时不触发，避免重复请求
    }
  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    this.voiceState = this.$store.state.voiceState
    this.cartState = this.$store.state.cartState
    // this.buyBox()
    this.getBoxInfo()
    this.getWinPeo()
  },
  mounted() {
  },
  beforeDestroy() { },
  methods: {
    goIndex() {
      this.$router.push({
        path: `/index`,
      });
    },
    voiceStateChange(e) {
      this.$store.commit("getVoiceState", e)
    },
    cartStateChange(e) {
      this.$store.commit("getCartState", e)
    },
    //音乐 结果
    playAlarm() {
      this.$refs.notify4.pause();
      this.$refs.notify.play();
    },
    //最近掉落
    getWinPeo() {
      let param = {
        box_id: this.box_id,
        show: 2,
        type: ''
      };
      this.$doGet("/api/hall.Box/latelynew", param).then((res) => {
        this.latelynewList = res.data
      }).catch(() => { })
    },
    //分享复制
    copyUrl() {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = window.location.href; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
      this.dialogFormVisible = false;
    },
    //盲盒信息
    getBoxInfo() {
      let param = {
        box_id: this.box_id,
      }
      this.$doGet(this.box_id != '' ? "/api/hall.Box/info" : '/api/hall.Box/newUserBox', param).then((res) => {
        this.box_obj = res.data
        this.box_name = res.data.name
        this.price = this.totalPrice = res.data.price
        this.skin_list = res.data.box_skins
        this.skins_types = res.data.skins_types
        this.checkPrice()
        // this.JiabuyBox()
      }).catch(() => { })
    },
    buyPrice() {
      this.$store.commit("setPaymentOpen", true)
    },
    //购买盲盒
    buyBox() {
      if (!this.$store.state.loginState) {
        this.$store.commit("getLogin", true);
        return;
      }
      if (this.chaMoney != 0) {
        return false
      }
      this.isThree = window.innerWidth < 540
      this.loading = true;
      let _this = this;
      let param = {
        box_id: this.box_obj.id,
        num: this.kaiBox,
        cartState: this.cartState
      }
      // 数据
      // let res = {
      //   data: {
      //     masonry: "0.00",
      //     player_skins_ids: [],
      //     skins_info: [],
      //     total_amount: "814840.19",
      //     total_price: "39.35",
      //   }
      // }
      // let obj = {
      //   box_id: 165,
      //   box_name: "枪林弹雨",
      //   color: "#F8F8FF",
      //   create_time: "2025-12-11 20:14:11",
      //   imageUrl: "http://47.94.52.130:9526/storage/file/a9eb43a634d8973777f8377b8c1b1233e6c67c1d.png",
      //   img: "http://47.94.52.130:9526/storage/csgo/skins/MjAyMCBSTVIgQ2hhbGxlbmdlcnM=.png",
      //   player_img: "http://47.94.52.130:9526/storage/file/93ee96eafbcac9c0df3221f71560e87496ff89cc.png",
      //   player_name: "王丫丫",
      //   skin_name: "2020 RMR 挑战组战队胶囊",
      // }
      // for (let i = 0; i < this.kaiBox; i++) {
      //   res.data.skins_info.push(obj)
      // }
      // 数据结束
      let imgCopy = JSON.parse(JSON.stringify(this.skin_list))
      let imgCopy2 = []
      for (let i = 0; i < Math.floor(60 / imgCopy.length) + 1; i++) {
        imgCopy2 = [...imgCopy2, ...imgCopy]
      }
      imgCopy2 = imgCopy2.slice(0, 60)
      this.$doPost("/api/hall.Box/buyBox", param).then((res) => {
        this.$store.commit("getAboutMon", res.data)
        const actualCount = Math.min(this.kaiBox, res.data.skins_info.length)
        let num = this.isThree ? 31 : 19
        this.imgList = []
        for (let i = 0; i < actualCount; i++) {
          this.imgList.push({
            zhongIndex: Math.floor(Math.random() * num),
            imgs: this.getRandomArr(imgCopy2, 60)
          });
        }
        this.loading = false
        let skins_info = res.data.skins_info;
        for (let i = 0; i < skins_info.length; i++) {
          if (skins_info[i]) {
            skins_info[i].background = skins_info[i].imageUrl
            // 确保 imgList[i] 存在
            if (this.imgList[i]) {
              this.imgList[i].imgs[40] = skins_info[i]
            }
          }
        }
        this.winList = skins_info.slice(0, actualCount)

        if (this.cartState && this.voiceState) {
          this.$refs.notify4.currentTime = 0
          this.$refs.notify4.play()
        }
        //是否开启动画
        if (!this.cartState) {
          this.winState = true
          if (this.voiceState) {
            this.playAlarm()
          }
        } else {
          if (!this.voiceState) {
            this.openBoxState = true
            var length = this.winList.length
            setTimeout(() => {
              this.openBoxState = false;
              this.winState = true;
              this.imgList = []
              if (this.voiceState) {
                this.playAlarm()
              }
            }, 6000 + 100 * length)
          }

        }
      }).catch(() => {
        this.loading = false
      })
    },
    onPlay() {
      this.openBoxState = true
      var length = this.winList.length
      setTimeout(() => {
        this.openBoxState = false;
        this.winState = true;
        this.imgList = []
        if (this.voiceState) {
          this.playAlarm()
        }
      }, 6000 + 100 * length)
    },
    // 音频播放事件
    handleAudioError() {
      this.openBoxState = true
      var length = this.winList.length
      setTimeout(() => {
        this.openBoxState = false;
        this.winState = true;
        this.imgList = []
        if (this.voiceState) {
          this.playAlarm()
        }
      }, 6000 + 100 * length)
    },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    checkPrice() {
      this.totalPrice = (this.price * this.kaiBox).toFixed(2)
      if (this.$store.state.loginState) {
        let price = this.price * this.kaiBox
        let myPrice = this.$store.state.masonry * 1 + this.$store.state.money * 1
        this.chaMoney = myPrice - price >= 0 ? 0 : (price - myPrice).toFixed(2)
        return false
      }
      this.chaMoney = 0
    },
    chooseNum(num) {
      this.kaiBox = num
      this.checkPrice()
    },
    //子组件修改父组件
    winexchange(msg) {
      this.winState = msg;
    },
    winget(msg) {
      this.winState = msg;
      this.buyBox()
    },
    winX(msg) {
      this.winState = msg;
    }
  },
};
</script>

<style lang="less" scoped>
.openbox-wai {
  .openbox {
    background: url(~@/assets/images/box/openbox-top.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-position: 50%;
    position: relative;
    .back-box-w {
      padding: 20px 0 0;
    }
    .back-box {
      color: #fff;
      cursor: pointer;
      i {
        margin-right: 8px;
      }
    }
    // 还未开奖的静态样式
    .kai-conm {
      padding-bottom: 70px;
      .conlist-warp {
        margin-top: 36px;
        display: flex;
        justify-content: center;
        .li-div {
          background: url(~@/assets/images/box/box-bg.png);
          background-size: 100% 100%;
          font-size: 16px;
          font-weight: bold;
          padding: 15px 10px 27px;
          text-align: center;
          margin: 0 10px;
          width: 250px;
          max-width: 250px;
          box-sizing: border-box;
          color: #fff;
          .bei1 {
            margin: 0 auto;
            max-width: 176px;
            aspect-ratio: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .img_main {
              width: 60%;
              height: 60%;
            }
            .img_active {
              width: 90%;
              height: auto;
              position: absolute;
              transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
            }
          }
          .money-warp {
            color: #ffc400;
            margin-top: 10px;
            img {
              margin-right: 4px;
            }
          }
          &:hover {
            .bei1 .img_active {
              animation: boxhover 0.6s ease-in-out;
            }
          }
        }
        @keyframes boxhover {
          0%,
          100% {
            transform: translateY(0);
          }
          25% {
            transform: translateY(-15px);
          }
          50% {
            transform: translateY(0);
          }
          75% {
            transform: translateY(-15px);
          }
        }
      }
      .openbox-bottom {
        margin-top: 24px;
      }
      .con-num {
        background: rgba(255, 255, 255, 0.3);
        padding: 4px 0;
        margin-right: 24px;
        .mun-li {
          width: 84px;
          height: 50px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #fff;
          cursor: pointer;
          &:hover {
            opacity: 0.8 !important;
          }
          &.con-num-check {
            background: #ffc400;
            font-weight: bold;
          }
        }
      }
      .error {
        font-weight: bold;
        font-size: 16px;
        color: #ff6060;
        margin-top: 6px;
        i {
          font-weight: bold;
          margin-right: 2px;
          font-size: 18px;
        }
      }
      .split-huo {
        color: #fff;
        margin: 0 20px;
      }
      .con-btn-w {
        display: inline-block;
        background: rgba(101, 80, 6, 0.6);
        padding: 3px 6px;
        position: relative;
        border-radius: 8px 0 8px 0;
        // margin-top: 60px;
        .con-btn {
          cursor: pointer;
          border-radius: 8px 0 8px 0;
          background-color: #ffc400;
          // background-color: #a59c7b;
          width: 240px;
          height: 54px;
          font-size: 16px;
          color: #2b2e3c;
          font-weight: 600;
          img {
            margin: 0 4px;
          }
        }
        &.con-btn-w-d {
          .con-btn {
            background-color: #a59c7b;
          }
        }
        &.con-btn-w-c {
          background: rgba(6, 91, 101, 0.6);
          .con-btn {
            background: #00f7ff;
          }
        }
      }
    }
  }
  .audio {
    display: none;
  }
  /* .share-hide {
    //height: 300px;
  }*/
  .share-btn {
    background-color: #333542;
    padding: 15px;
    display: flex;
    .btn {
      margin-left: 10px;
    }
  }
  .skin-list-item {
    padding: 70px 0;
    .csgo-title {
      margin-bottom: 20px;
    }
  }
}
.ding-box {
  position: relative;
}
</style>
<style type="text/css">
.openbox-swiper {
  --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
}
</style>
